export default __webpack_public_path__ + "static/media/rozpravkovo.2e7f7925.svg";